export default () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M521.142857 576h242.285714a36.571429 36.571429 0 0 1 0 73.142857H484.571429a36.571429 36.571429 0 0 1-36.278858-41.142857 36.937143 36.937143 0 0 1-0.292571-4.571429V228.571429a36.571429 36.571429 0 0 1 73.142857 0v347.428571zM512 1024C229.229714 1024 0 794.770286 0 512S229.229714 0 512 0s512 229.229714 512 512-229.229714 512-512 512z m0-73.142857c242.358857 0 438.857143-196.498286 438.857143-438.857143S754.358857 73.142857 512 73.142857 73.142857 269.641143 73.142857 512s196.498286 438.857143 438.857143 438.857143z"
        fill="#333333"
      />
    </svg>
  );
};
